// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2gYLN","tableWrap":"styles_tableWrap__1Llgg"};